import React from 'react';

import { OnlineBookingUnavailableMessageContainer } from './OnlineBookingUnavailableMessage.styled';
import {
  ONLINE_BOOKING_UNAVAILABLE_MESSAGE,
  ONLINE_BOOKING_UNAVAILABLE_PHONE_HREF,
  ONLINE_BOOKING_UNAVAILABLE_PHONE_NUMBER
} from 'kb-shared/booking/utils/onlineBookingAvailability';

export const OnlineBookingUnavailableMessage = ({ compact = false }: { compact?: boolean }) => (
  <OnlineBookingUnavailableMessageContainer $compact={compact} role="alert">
    {ONLINE_BOOKING_UNAVAILABLE_MESSAGE}{' '}
    <a href={ONLINE_BOOKING_UNAVAILABLE_PHONE_HREF}>{ONLINE_BOOKING_UNAVAILABLE_PHONE_NUMBER}</a>.
  </OnlineBookingUnavailableMessageContainer>
);
